export default __webpack_public_path__ + "static/media/liv.fb510102.svg";